import React from "react";
import { tokenAlias } from "./constants";
export const UserInfo = React.createContext({
  loading: true,
  [tokenAlias]: localStorage.getItem(tokenAlias),
});
